import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-register-success',
  standalone: false,
  templateUrl: './register-success.component.html',
  styleUrl: './register-success.component.scss',
})
export class RegisterSuccessComponent {
  message =
    history.state?.message ??
    'Account created. Please check your email to verify your account.';

  constructor(private router: Router) {}
}
